import React, {useState, useEffect} from "react"
import './styles/App.scss'
import {graphql} from 'gatsby'
import {Helmet} from 'react-helmet'
import Content from '../components/Content/Content'
import Footer from '../components/Footer/Footer'
import MainIllustration from '../components/MainIllustration/MainIllustration'

export default ({data}) => {

	const [scrollTop, setScrollTop] = useState(false)

	const scrollHandler = () => {
		if(document.documentElement.scrollTop > 400) {
			setScrollTop(true)
		} else {
			setScrollTop(false)
		}
	}

	const scrollToTop = () => {
		document.documentElement.scrollTop = 0
	}

	useEffect(() => {
		window.addEventListener('scroll', scrollHandler)
		return () => {
			window.removeEventListener('scroll', scrollHandler)
		}
	}, [])

	const {
		page: {
			layout: {
				mainIllustration: {
					points
				},
				blocks: content
			}
		}
	} = data

	return(
		<>
			<Helmet>
				<title>OHC kart</title>
			</Helmet>
			<main>
				<MainIllustration points={points} />
				{ content.length > 0 && <Content content={content} /> }
				{
					scrollTop &&
					<button className="scrollTop" onClick={() => scrollToTop()}>Scroll to top</button>
				}
			</main>
			<Footer />
		</>
	)
}

export const query = graphql`
	query pageQuery {
		page: wpPage(slug:{eq:"page"}) {
			layout {
				mainIllustration {
					points {
						title
						active
						content {
							title
							content
							link {
								target
								url
								title
							}
						}
						settings {
							area {
								width
								height
								bottom
								left
							}
							point {
								top
								left
							}
							panel {
								top
								left
							}
						}
					}
				}
				blocks {
					illustration
					title
					content
					facts {
						text
						title
					}
					infoBoxes {
						title
						content
					}
				}
			}
		}
	}
`